<template>
  <div class="comment">
    <div class="container">
      
      <p class="comment_title">你想對這場世紀災難說什麼話，或對這些人有什麼祝福的話</p>

      <div class="comment_share">

        <div class="comment_share_fb">
          <div class="fb-like" :data-href="href" data-layout="button_count" data-action="like" data-size="small" data-show-faces="true" data-share="true"></div>
        </div>
        
        <div class="comment_share_line" @click="shareToLine">
          <img class="comment_line_image" src="//media.line.me/img/button/zh-hant/84x20.png" width="84" height="20" alt="LINE分享給朋友">
        </div>

      </div>
      

      <div class="fb-comments" :data-href="href" data-numposts="5" data-width="100%" data-order-by="reverse_time"></div>

    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils'

export default {
  name: 'Comment',
  props: {
    href: String
  },
  mounted () {
    FB.XFBML.parse()
    this.isMobile = Utils.detectMob()
    this.isInApp = Utils.isFacebookApp(148) || Utils.isLineApp()
  },
  data() {
    return {
      isMobile: false,
      isInApp: false
    }
  },
  methods: {
    shareToLine() {
      // if (window.innerWidth<768) {
      //   // 手機
      //   window.location.href = `https://line.me/R/msg/text/?${encodeURIComponent(document.querySelector('title').innerHTML)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href)}`
      // } else {
      //   window.open(`https://social-plugins.line.me/lineit/share?text=${encodeURIComponent(document.querySelector('title').innerHTML)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A&url=${encodeURIComponent(this.href)}`)
      // }

      if (!this.isMobile) {
        window.open(`https://social-plugins.line.me/lineit/share?text=${encodeURIComponent(document.querySelector('title').innerHTML)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A&url=${encodeURIComponent(this.href)}`)
      } else if (!this.isInApp) {
        window.location.href = `https://line.me/R/msg/text/?${encodeURIComponent(document.querySelector('title').innerHTML)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href)}`
      } else {
        window.location.href = `https://line.me/R/msg/text/?${encodeURIComponent(document.querySelector('title').innerHTML)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href)}`
      }


      ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'Share',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}][${document.querySelector('title').innerHTML}][Click_Linebottom_${document.querySelector('title').innerHTML}]`,
      });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.comment {
  width: 100%;
}

.comment_title {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 30px;
  font-size: 1.5rem;
  @media (min-width: 768px) and (max-width: 1279.98px) {
    font-size: 2rem;
    margin-top: 100px;
  }
  @media (min-width: 1280px) {
    font-size: 2rem;
    margin-top: 120px;
  }
}
.comment_share {
  display: flex;
  margin-top: 30px;
}

.comment_share_fb {
  margin-right: 8px;
}

.comment_share_line {
  cursor: pointer;
}
</style>
